import React from 'react';
import { Award, CheckCircle, FileText, Calendar, Shield } from 'lucide-react';

const Certification = ({ certification }) => {
  return (
    <div className="certification-page">
      {/* Header */}
      <section className="hero" style={{
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2)), url("/images/iso.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="container">
          <h1 className="hero-title">Certification ISO 9001:2015</h1>
          <p className="hero-subtitle">
            Notre engagement envers l'excellence et la qualité
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="form-container">
            <div style={{ display: 'flex', alignItems: 'center', gap: '25px', marginBottom: '30px' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: 'linear-gradient(135deg, #28a745, #20c997)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Award size={40} color="white" />
              </div>
              <div>
                <h2 className="form-title">{certification.nom}</h2>
                <h3 style={{ color: '#28a745', fontWeight: '600' }}>{certification.titre}</h3>
              </div>
            </div>

            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '30px' }}>
              {certification.description}
            </p>

            {/* Infos certification */}
            <div style={{ 
              background: '#f8f9fa', 
              padding: '25px', 
              borderRadius: '10px',
              marginBottom: '40px'
            }}>
              <h4 style={{ color: '#0A2E5C', marginBottom: '20px', fontSize: '18px' }}>
                Informations de Certification
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <Calendar size={18} color="#007BFF" />
                  <div>
                    <strong>Date de certification :</strong> {certification.dateCertification}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <Calendar size={18} color="#28a745" />
                  <div>
                    <strong>Date de renouvellement :</strong> {certification.dateRenouvellement}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FileText size={18} color="#fd7e14" />
                  <div>
                    <strong>Organisme certificateur :</strong> {certification.organisme}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certificat ISO */}
      <section className="section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">Notre Certificat ISO 9001:2015</h2>
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <div style={{ 
              background: 'white', 
              padding: '30px', 
              borderRadius: '10px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
              marginBottom: '20px'
            }}>
              <img 
                src="/images/certif_final.jpg" 
                alt="Certificat ISO 9001:2015 - Nitrokym"
                style={{ 
                  maxWidth: '100%', 
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: '0 3px 15px rgba(0,0,0,0.1)',
                  border: '8px solid #0A2E5C',
                  background: 'white',
                  padding: '10px'
                }}
              />
            </div>
            <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>
              Ce certificat atteste de notre conformité aux normes internationales de management de la qualité 
              et de notre engagement continu envers l'excellence opérationnelle.
            </p>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">Avantages pour nos clients</h2>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <div style={{ 
              background: 'white', 
              padding: '30px', 
              borderRadius: '10px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.05)'
            }}>
              {certification.avantages.map((avantage, index) => (
                <div key={index} style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  gap: '15px',
                  marginBottom: '20px',
                  paddingBottom: '20px',
                  borderBottom: index < certification.avantages.length - 1 ? '1px solid #e9ecef' : 'none'
                }}>
                  <CheckCircle size={20} color="#28a745" style={{ marginTop: '3px', flexShrink: 0 }} />
                  <div>
                    <h4 style={{ color: '#0A2E5C', marginBottom: '5px' }}>
                      Avantage {index + 1}
                    </h4>
                    <p style={{ color: '#666', lineHeight: '1.6' }}>{avantage}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Processus Qualité */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Notre Système de Management de la Qualité</h2>
          <div className="certifications-grid">
            <div className="cert-card">
              <FileText size={40} color="#007BFF" style={{ marginBottom: '20px' }} />
              <h3 className="cert-name">Documentation</h3>
              <p className="cert-desc">
                Procédures documentées pour tous les processus, garantissant 
                la reproductibilité et la traçabilité.
              </p>
            </div>

            <div className="cert-card">
              <Shield size={40} color="#28a745" style={{ marginBottom: '20px' }} />
              <h3 className="cert-name">Contrôle Qualité</h3>
              <p className="cert-desc">
                Contrôles rigoureux à chaque étape, de la matière première 
                au produit fini.
              </p>
            </div>

            <div className="cert-card">
              <CheckCircle size={40} color="#fd7e14" style={{ marginBottom: '20px' }} />
              <h3 className="cert-name">Amélioration Continue</h3>
              <p className="cert-desc">
                Processus d'amélioration continue basé sur les retours clients 
                et les audits internes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Engagement */}
      <section className="hero" style={{ background: 'linear-gradient(to right, #28a745, #20c997)' }}>
        <div className="container">
          <h2 className="hero-subtitle">Notre Engagement Qualité</h2>
          <p className="hero-text">
            La certification ISO 9001:2015 n'est pas un aboutissement, mais le début 
            de notre engagement continu envers l'excellence opérationnelle.
          </p>
          <div style={{ 
            background: 'rgba(255,255,255,0.1)', 
            padding: '25px', 
            borderRadius: '10px',
            maxWidth: '600px',
            margin: '30px auto',
            textAlign: 'center'
          }}>
            <Award size={40} color="white" style={{ marginBottom: '15px' }} />
            <h3 style={{ color: 'white', marginBottom: '10px', fontSize: '20px' }}>
              Qualité Garantie
            </h3>
            <p style={{ color: '#dbeafe' }}>
              Chaque produit Nitrokym porte la garantie de notre certification 
              et de notre engagement qualité total.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Certification;